import React from 'react';
import { t, props } from 'tcomb-react';

@props({
  html: t.Str,
  children: t.Any
})
export default class PurchaseStripeGateway extends React.Component {

  componentDidMount() {
    $('#stripeGatway').html(this.props.html);
  }

  render() {
    return (
      <div>
        <div id="stripeGatway"></div>
        <div>
          {this.props.children}
        </div>
        <hr/>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/PurchaseStripeGateway.js
 **/